import { PenOfferStatusDto } from './PenOfferStatus';

export class CreatePenOfferDto {
  QuoteNumber: string;
  QuoteIdCRM?: number;
  CustomerId: number;
  NumberOfPens: number;
  DeliveryDate: number;
  PenDesignTypeId: number;
}

export class CreatePenOfferResponseDto {
  PenOfferId: number;
  PenId: number;
}

export class PenOfferListItemDto {
  Id: number;
  QuoteNumber: string;
  CustomerName: string;
  SiteName: string;
  ResponsibleUserName: string;
  NumberOfPens: number;
  DeliveryDate: Date;
  OfferValidToDate: Date;
  PenOfferStatus: PenOfferStatusDto;
  Created: Date;
  PenId: number;
}

export class PenOfferDto {
  Id: number;
  QuoteNumber: string;
  QuoteIdCRM: number;
  ProjectName: string;
  CustomerId: number;
  Customer: CustomerInfoDto;
  DepartmentId: number;
  SiteId: number;
  ContactId: number;
  DeliveryDate: Date;
  OfferValidToDate: Date;
  NumberOfPens: number;
  ResponsibleUserId: string;
  PenId: number;
  PenOfferStatusId: number;
  PenOfferStatus: PenOfferStatusDto;
  NetStandardId: number;
  PriceIndication?: number;
  MilestoneProjectCalculation: Date;
  MilestoneContractSignature: Date;
  MilestoneFirstDelivery: Date;
  MilestoneLastDelivery: Date;
  Comment: string;
  PenOfferScopeId: number;
}

export class CustomerInfoDto {
  Id: string;
  Name: string;
}

export class ContactInfoDto {
  Name: string;
  Phone: string;
}
